'use client'

import { Button } from '@mentora/ui-components'
import posthog from 'posthog-js'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // A boundary-caught render error never reaches window.onerror, so the SDK's
  // automatic capture misses it. Dropped while the visitor has not consented.
  useEffect(() => {
    posthog.captureException(error, { digest: error.digest })
  }, [error])

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold">Something went wrong</h1>
      <p className="text-muted-foreground max-w-md">
        We hit an unexpected error. You can try again or reload the page.
      </p>
      {error.digest && (
        <p className="text-muted-foreground text-xs">
          Reference:
          {error.digest}
        </p>
      )}
      <Button onClick={() => reset()}>Try again</Button>
    </div>
  )
}
